module.exports = __webpack_public_path__ + "img/R. Saadia Alfon.de0a67c6.png";